import { zhCN } from '../../../core/i18n/zhCN';
import { useSettingsStore } from '../../../store/settingsStore';

function VolumeControl({
  label,
  value,
  onChange,
}: {
  label: string;
  value: number;
  onChange(value: number): void;
}) {
  const percent = Math.round(value * 100);
  return (
    <label className="volume-control">
      <span>
        {label}
        <output>{percent}%</output>
      </span>
      <input
        type="range"
        min="0"
        max="100"
        step="5"
        value={percent}
        aria-label={label}
        onChange={(event) => onChange(Number(event.target.value) / 100)}
      />
    </label>
  );
}

export function AudioSettingsPanel() {
  const panelOpen = useSettingsStore((state) => state.panelOpen);
  const audio = useSettingsStore((state) => state.audio);
  const actions = useSettingsStore((state) => state.actions);
  if (!panelOpen) return null;

  return (
    <div className="settings-backdrop" role="presentation" onClick={actions.closePanel}>
      <section
        className="settings-panel"
        role="dialog"
        aria-modal="true"
        aria-labelledby="audio-settings-title"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="settings-heading">
          <div>
            <span className="eyebrow">AUDIO</span>
            <h2 id="audio-settings-title">{zhCN.audio.title}</h2>
          </div>
          <span aria-hidden="true">🎧</span>
        </div>
        <VolumeControl
          label={zhCN.audio.music}
          value={audio.musicVolume}
          onChange={actions.setMusicVolume}
        />
        <VolumeControl
          label={zhCN.audio.sfx}
          value={audio.sfxVolume}
          onChange={actions.setSfxVolume}
        />
        <p>{zhCN.audio.description}</p>
        <button className="primary-button" onClick={actions.closePanel}>
          {zhCN.audio.close}
        </button>
      </section>
    </div>
  );
}
